import { OENOperationMode } from "../enums/oe-operation-mode.enum";
import { OENEntryType } from "../enums/oe-entry-type.enum";
import { OENDisplayState } from "../enums/oe-display-state.enum";

export class OEScreenRegistryData {
  public rootRefId: string = null;
  public refIds: Array<string> = new Array<string>();
  public operationMode: OENOperationMode = null;
  public entryType: OENEntryType = null;
  public displayState: OENDisplayState = null;
}
